export const environment = {
  production: true,
  tealium: {
    account: 'aa',
    profile: 'main'
  },
  baseHref: '/selfServiceRefund'
};
